module.exports = __webpack_public_path__ + "assets/arrow_down-089134.svg";